import { setCountAction, setHeadlineTypeSync } from "./_common.js";
import schoolTypeFilter from "./school-type-filter.js";

const main = () => {
    if (document.querySelector('#page-search-school') == null) return;

    document.querySelector('select[name="school_area"]').addEventListener('change', (e) => {
        const urlBase = location.href.replace(/\/\d+$/, '').replace(/\/$/, '');
        location.href = `${urlBase}/${e.currentTarget.value}`;
    });
    setCountAction();
    setHeadlineTypeSync();
    schoolTypeFilter();
}

export default main
